import { render, staticRenderFns } from "./add-permission.vue?vue&type=template&id=3b4a8587&scoped=true"
import script from "./add-permission.vue?vue&type=script&lang=js"
export * from "./add-permission.vue?vue&type=script&lang=js"
import style0 from "./add-permission.vue?vue&type=style&index=0&id=3b4a8587&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a8587",
  null
  
)

export default component.exports